<div class="promote-component">
  <img class="promote-bg" src="assets/splash-bg.jpg" />
  <img class="pilot-logo" src="assets/theFoodChecker-logo-col1-withStrap.svg" />
  <span class="promotion-wrapper">
    <span class="title">Find out more about the food you eat…</span>
    <span class="promotion">
      <p>
        If you are seeing this page, you may have entered the wrong web address!
        Please re-check the web address and try again.
      </p>
      <br />
      <p>
        If you are interested in 'The Food Checker’ and would like to find out
        more how it could help your customers find out more about the food you
        provide please
        <a href="http://pelicanprocurement.co.uk/"
          >contact us.</a
        >
      </p>
    </span>
  </span>
</div>
